import { CSSProperties, FC } from 'react';
import { styled } from '@mui/material/styles';

interface CertificationHistoryIconProps {
  size?: number | string;
  color?: string;
  style?: CSSProperties;
}

const StyledSvg = styled('svg')({});

const CertificationHistoryIcon: FC<CertificationHistoryIconProps> = ({
  size = 24,
  color = 'currentColor',
  style,
}) => (
  <StyledSvg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 85.41 88.76"
    width={size}
    height={size}
    fill={color}
    style={style}
  >
    <path d="M16.67,66.69v-8.34h13.56c.78-2.96,1.96-5.76,3.49-8.34h-17.04v-8.34h24.08c5.72-4.85,13.11-7.78,21.19-7.78,1.61,0,3.2.12,4.75.35v-9.24L41.68,0H8.34C3.75,0,.04,3.75.04,8.34l-.04,66.69c0,4.59,3.71,8.34,8.29,8.34h25.42c-2.89-4.89-4.56-10.58-4.56-16.67h-12.48ZM37.51,6.25l22.93,22.93h-22.93V6.25Z" />
    <polygon points="59.34 54.86 59.34 67.9 70.5 74.52 72.37 71.37 63.25 65.94 63.25 54.86 59.34 54.86" />
    <path d="M61.94,41.83c-12.96,0-23.47,10.51-23.47,23.47h-7.82l10.14,10.14.18.37,10.53-10.51h-7.82c0-10.09,8.16-18.25,18.25-18.25s18.25,8.16,18.25,18.25-8.16,18.25-18.25,18.25c-5.03,0-9.6-2.06-12.88-5.37l-3.7,3.7c4.25,4.25,10.09,6.88,16.58,6.88,12.96,0,23.47-10.51,23.47-23.47s-10.51-23.47-23.47-23.47Z" />
  </StyledSvg>
);

export default CertificationHistoryIcon;
